import { defineStore } from 'pinia'
import { ref } from 'vue'
import router from '@/router'

export interface TopBarBreadcrumbItem {
  label: string
  href?: string
  clickable?: boolean
}

export interface TopBarStoredBreadcrumbItem {
  label: string
  hrefKey?: string
  onClick: () => void
}

interface TopBarPayload {
  title?: string
  breadcrumbs?: TopBarBreadcrumbItem[]
}

export const useTopBarStore = defineStore('topBar', () => {
  const title = ref('')
  const breadcrumbs = ref<TopBarStoredBreadcrumbItem[]>([])
  const showSearch = ref(false)

  const searchString = ref('')
  const searchResults = ref([])
  const searchPlaceholder = ref('Search resources...')

  const setSearchPlaceholder = (newSearchPlaceholder: string) => {
    searchPlaceholder.value = newSearchPlaceholder
  }

  const setTitle = (newTitle: string) => {
    title.value = newTitle
  }

  const onBreadcrumbClick = (breadcrumb: TopBarBreadcrumbItem) => {
    router.push(breadcrumb.href || '/')
  }

  const setBreadcrumbs = (newBreadcrumbs: TopBarBreadcrumbItem[] = []) => {
    breadcrumbs.value = newBreadcrumbs.map(breadcrumb => ({
      label: breadcrumb.label,
      hrefKey: breadcrumb.href,
      onClick: () => onBreadcrumbClick(breadcrumb),
    }))
  }

  const setShowSearch = (newShowSearch: boolean) => {
    showSearch.value = newShowSearch
  }

  const setSearchString = (newSearchString: string) => {
    searchString.value = newSearchString
  }

  const setSearchResults = (newSearchResults: any[]) => {
    searchResults.value = newSearchResults
  }

  const resetTopBar = () => {
    title.value = ''
    breadcrumbs.value = []
  }

  return {
    title,
    breadcrumbs,
    showSearch,
    searchString,
    searchResults,
    searchPlaceholder,
    setTitle,
    setBreadcrumbs,
    setShowSearch,
    setSearchString,
    setSearchResults,
    resetTopBar,
    setSearchPlaceholder,
    onBreadcrumbClick,
  }
})
